import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../providers/ThemeContext";
import { RippleButton } from "./RippleButton";

interface ThemeToggleProps {
  className?: string;
  iconClassName?: string;
  hoverColor?: string;
  textColor?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  className = "",
  iconClassName = "w-6 h-6",
  hoverColor,
  textColor = "text-dark",
}) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <RippleButton
      color="bg-transparent"
      hoverColor={hoverColor || "bg-stroke/20 dark:bg-white/10"}
      padding="p-3"
      radius="rounded-full"
      onTap={toggleTheme}
      className={`border-none ${className}`}
    >
      {theme === "light" ? (
        <Moon className={`${iconClassName} ${textColor} transition-all duration-300`} />
      ) : (
        <Sun className={`${iconClassName} ${textColor} transition-all duration-300`} />
      )}
    </RippleButton>
  );
};
